import { gql } from '@apollo/client'

import { LOCATION_LIST_FRAGMENT } from '../fragments'

const BULK_UPDATE_LOCATIONS_MUTATION = gql`
  mutation bulkUpdateLocations($ids: [ID!]!, $data: LocationUpdateInput!) {
    bulkUpdateLocations(ids: $ids, data: $data) {
      ...LocationListFragment
    }
  }
  ${LOCATION_LIST_FRAGMENT}
`

export default BULK_UPDATE_LOCATIONS_MUTATION
